import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { SessionService } from '../services/session.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {
    isAdmin: boolean;
    constructor(private sessionService: SessionService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        this.sessionService.getUserType() === 'PORTAL' ? this.isAdmin = false : this.isAdmin = true;
        if(!this.isAdmin) {
            if((state.url.indexOf('member') > -1 && state.url.indexOf('reporting') === -1) || state.url.indexOf('offer') > -1 ||
                (state.url.indexOf('order') > -1 && state.url.indexOf('reporting') === -1) || state.url.indexOf('employ') > -1 || state.url.indexOf('product') > -1 ||
                state.url.indexOf('reporting-internal-orders') > -1 ) {
                    this.router.navigate(['/']);
                    return false;

                }
        }
        if (this.sessionService.isAuthenticated() ) {
            return true;
        } else {
            if(this.sessionService.checkStorageSession() == null) {
                this.router.navigate(['/']); /// guard does not have from where to take refresh token and make call
            } else {
                return true;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/authorization.guard.ts